











































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { vxm } from '@/store';
import { DocumentListLevel, DocumentsFilter, getEmptyDocumentsFilter } from '../document-models';
import { IInputIcon } from '../../global/common-models';
import OtTextField from '@/components/global/ot-text-field.vue';
import { OtProjectContract, Project } from '@/areas/projects/project-models';
import { ProfileOrganisationModel } from '@/areas/profile/models';
import OtApi, { executeApi } from '@/services/api.service';
import { PermissionLevel } from '@/services/generated/api';
import OtMultiSelectAutocomplete, { IKeyedAutocompleteItem } from '../../global/ot-multi-select-autocomplete.vue';
import OtDatePicker from '@/components/global/ot-date-picker.vue';
import { ZonelessDate } from '@/types/zoneless-date';
import OtCheckbox from '@/components/global/ot-checkbox.vue';
import OtCheckboxGroup, { CheckboxGroupItem } from '@/components/global/checkbox-group/ot-checkbox-group.vue';
import { DocumentSource as ApiDocumentSource } from '@/services/generated/api';

@Component({
  components: {
    OtTextField,
    OtMultiSelectAutocomplete,
    OtDatePicker,
    OtCheckbox,
    OtCheckboxGroup,
  },
})
export default class OtDocumentsFilter extends Vue {
  // * PROPS
  // Do we want filters coming in? We're in charge of them. We can just raise the event
  // We don't really want to have to watch the incoming filters and react to changes externally
  // Later, we could. Now, we don't want to
  // @Prop() private filters!: DocumentsFilter;
  @Prop() private level!: DocumentListLevel;
  @Prop({ default: '' }) private organisationGid!: string;
  @Prop({ default: '' }) private projectGid!: string;

  // * REFS
  @Ref('rootRef') private readonly rootRef!: HTMLDivElement;
  // * DATA
  private icon: IInputIcon = {
    icon: '$search',
    iconColor: 'black',
    action: null,
  };

  private loading = false;
  private api = new OtApi();
  private filters = getEmptyDocumentsFilter();
  private projects: Project[] = [];
  private contentDescriptions: string[] = [];
  private userOrganisations: ProfileOrganisationModel[] = [];

  // no need for a getter and setter for key word search value
  // just need a backing variable for this. We'll update the filter on blur
  private keywordSearchVal = '';

  // * COMPUTED

  // backing collections for the items for the autocompletes
  private showOrganisations = false;
  private showProjects = false;
  private showContracts = false;

  private selectableOrganisations: IKeyedAutocompleteItem<ProfileOrganisationModel>[] = [];
  private selectableProjects: IKeyedAutocompleteItem<Project>[] = [];
  private selectableContracts: IKeyedAutocompleteItem<OtProjectContract>[] = [];
  private selectableContentDescriptions: IKeyedAutocompleteItem<undefined>[] = [];

  // need a bunch of backing collections for the selected items for the auto completes - getter, setter, updateFilters when the value changes
  private selectedOrganisationsPrivate: IKeyedAutocompleteItem<ProfileOrganisationModel>[] = [];
  private get selectedOrganisations() {
    return this.selectedOrganisationsPrivate;
  }
  private set selectedOrganisations(val: IKeyedAutocompleteItem<ProfileOrganisationModel>[]) {
    this.selectedOrganisationsPrivate = val;
    this.updateFilters({
      // we're filtering out the ones with a truthy data, so we can use ! on data
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      organisationGids: val.filter(x => x.data).map(x => x.data!.gid),
    });
  }

  private selectedProjectsPrivate: IKeyedAutocompleteItem<Project>[] = [];
  private get selectedProjects() {
    return this.selectedProjectsPrivate;
  }
  private set selectedProjects(val: IKeyedAutocompleteItem<Project>[]) {
    this.selectedProjectsPrivate = val;
    this.updateFilters({
      // we're filtering out the ones with a truthy data, so we can use ! on data
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      projectGids: val.filter(x => x.data).map(x => x.data!.gid),
    });
  }

  private selectedContractsPrivate: IKeyedAutocompleteItem<OtProjectContract>[] = [];
  private get selectedContracts() {
    return this.selectedContractsPrivate;
  }
  private set selectedContracts(val: IKeyedAutocompleteItem<OtProjectContract>[]) {
    this.selectedContractsPrivate = val;
    this.updateFilters({
      // we're filtering out the ones with a truthy data, so we can use ! on data
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      contractGids: val.filter(x => x.data).map(x => x.data!.gid),
    });
  }

  private selectedContentDescriptionsPrivate: IKeyedAutocompleteItem<void>[] = [];
  private get selectedContentDescriptions() {
    return this.selectedContentDescriptionsPrivate;
  }
  private set selectedContentDescriptions(val: IKeyedAutocompleteItem<void>[]) {
    this.selectedContentDescriptionsPrivate = val;
    this.updateFilters({
      // we're filtering out the ones with a truthy data, so we can use ! on data
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      contentDescriptions: val.map(x => x.key),
    });
  }

  private dateFromPrivate: Date | null = null;
  private get dateFrom() {
    return this.dateFromPrivate;
  }
  private set dateFrom(val: Date | null) {
    this.dateFromPrivate = val;
    this.updateFilters({ dateFrom: val ? new ZonelessDate(val) : undefined });
  }
  private dateToPrivate: Date | null = null;
  private get dateTo() {
    return this.dateToPrivate;
  }
  private set dateTo(val: Date | null) {
    this.dateToPrivate = val;
    this.updateFilters({ dateTo: val ? new ZonelessDate(val) : undefined });
  }

  private includeMyUnassociatedDocumentsPrivate = false;
  private get includeMyUnassociatedDocuments() {
    return this.includeMyUnassociatedDocumentsPrivate;
  }
  private set includeMyUnassociatedDocuments(val: boolean) {
    this.includeMyUnassociatedDocumentsPrivate = val;
    this.updateFilters({ includeMyUnassociatedDocuments: val });
  }

  private get isLevelGlobal() {
    const result = this.level === DocumentListLevel.Global;
    console.log('isLevelGlobal', this.level, result);
    return result;
  }

  private documentSourceFilters: CheckboxGroupItem<ApiDocumentSource>[] = [
    new CheckboxGroupItem('OneTrack', ApiDocumentSource.OneTrack),
    new CheckboxGroupItem('Aconex Mail', ApiDocumentSource.AconexMail),
    new CheckboxGroupItem('Aconex Document', ApiDocumentSource.AconexDocument),
  ];
  private selectedDocumentSourceFiltersPrivate: CheckboxGroupItem<ApiDocumentSource>[] = [];
  private get selectedDocumentSourceFilters() {
    return this.selectedDocumentSourceFiltersPrivate;
  }
  private set selectedDocumentSourceFilters(val: CheckboxGroupItem<ApiDocumentSource>[]) {
    this.selectedDocumentSourceFiltersPrivate = val;
    this.updateFilters({ documentSource: val.map(x => x.value) });
  }

  // TODO some rules/error message collections that validate that the from is not > the to?

  // * WATCHERS

  // * METHODS

  private async getProjects() {
    const apiResponse = await executeApi(() => this.api.projects().getProjects(PermissionLevel.View), 'Load Projects');
    if (apiResponse.success && apiResponse.data?.projects) {
      this.projects = apiResponse.data.projects.map(s => Project.createFromApiResponse(s));
    }
  }

  private async getUserOrganisations() {
    const results = await vxm.userProfile.getUserProfile();
    if (results) {
      this.userOrganisations = results.organisations;
    }
  }

  private async getContentDescriptions() {
    const results = await executeApi(
      () => this.api.documents().getDocumentContentDescriptionList(),
      'Load Document Content List',
    );
    if (results.data) {
      this.contentDescriptions = results.data;
    }
  }

  private handleKeywordBlur() {
    if (this.keywordSearchVal !== this.filters.keyword) {
      this.updateFilters({
        keyword: this.keywordSearchVal,
      });
    }
  }

  private updateFilters(updates: Partial<DocumentsFilter>) {
    const next = { ...this.filters, ...updates };
    this.filters = next;
    this.$emit('onFilter', next);
  }

  private async initialise() {
    this.loading = true;
    await Promise.all([this.getProjects(), this.getContentDescriptions()]);

    // Yep. Same thing for the autocomplete items key and label
    // The multi select auto complete really wants a keyed one auto complete item
    // We don't have a dumb "key and label are the same" type for this. We could. We do not.
    // Dan couldn't be bothered with the type gymnastics required to get the inheritence/extends chain correct for that
    // We also don't have a Keyed But No Data interface. Again, gymnastics, Dan is too old to care. This works
    this.selectableContentDescriptions = this.contentDescriptions.map(x => ({
      key: x,
      label: x,
      data: undefined,
    }));

    if (this.level === DocumentListLevel.Global) {
      this.showOrganisations = true;
      this.showProjects = true;
      this.showContracts = true;
      // get the profile to get the organisations
      await this.getUserOrganisations();
      this.selectableOrganisations = this.userOrganisations.map(o => ({
        data: o,
        key: o.gid,
        label: o.name,
      }));
      // all the projects. Probably should put the org name in? Conditionally if there's more than one org?
      this.selectableProjects = this.projects.map(p => ({
        data: p,
        key: p.gid,
        label: `${p.code}: ${p.name}`,
      }));
      // all the contracts. Again, probably should put the organisation name in, if there's more than one org
      // don't really need the project name if there's only one project as well, but meh
      this.selectableContracts = this.projects.flatMap(p =>
        p.contracts.map(c => ({
          data: c,
          key: c.gid,
          label: `${p.code}: ${p.name} - ${c.reference}: ${c.name}`,
        })),
      );
    } else if (this.level === DocumentListLevel.Organisation) {
      this.showOrganisations = false;
      this.showProjects = true;
      this.showContracts = true;
      if (!this.organisationGid) {
        console.error(
          'Documents Filter: Level is Organisation but no organisation gid was provided. Project and contract lists will be empty',
        );
      }
      // projects for this org
      // no need to put the org name in, there is only one org at play
      const matchingProjects = this.projects.filter(p => p.organisationGid === this.organisationGid);
      this.selectableProjects = matchingProjects.map(p => ({
        data: p,
        key: p.gid,
        label: p.name,
      }));
      // contracts for the projects for this org
      this.selectableContracts = matchingProjects.flatMap(p =>
        p.contracts.map(c => ({
          data: c,
          key: c.gid,
          label: `${p.name} - ${c.name}`,
        })),
      );
    } else if (this.level === DocumentListLevel.Project) {
      this.showOrganisations = false;
      this.showProjects = false;
      this.showContracts = true;
      if (!this.projectGid) {
        console.error(
          'Documents Filter: Level is Project but no project gid was provided. Contract list will be empty',
        );
      }

      // no need to build the list of projects, it's not filterable
      // contracts for this project
      this.selectableContracts = this.projects
        .filter(p => p.gid === this.projectGid)
        .flatMap(p =>
          p.contracts.map(c => ({
            data: c,
            key: c.gid,
            // don't need the project name in here, we only have contracts from this project
            label: c.name,
          })),
        );
    }
    // no autocomplete filtering at contract or workflow level
    // else if (this.level === DocumentListLevel.Contract) {
    // } else if (this.level === DocumentListLevel.Workflow) {
    // }
    this.loading = false;
  }

  public reset() {
    this.updateFilters(getEmptyDocumentsFilter());
    this.initialise();
  }

  // * LIFECYCLE
  private async created() {
    this.initialise();
  }
}
